import { ComponentProps } from 'react';
import { formatDate } from 'utils/functions/Date';

import { styled } from '@project44/manifest-ds';
import { Nullable } from '@project44-models/shipment-list';

const DATE_TIME_LONG_FORMAT = 'MMM d, yyyy H:mm z';

const CellDateContainer = styled('span');

interface ITableCellDateProps {
  dateTime?: Nullable<string>;
  css?: ComponentProps<typeof CellDateContainer>['css'];
}

function TableCellDate({ dateTime, css }: ITableCellDateProps) {
  return (
    <CellDateContainer css={css}>
      {dateTime ? formatDate(dateTime, DATE_TIME_LONG_FORMAT) : '-'}
    </CellDateContainer>
  );
}

export default TableCellDate;
